export default "__VITE_ASSET__B2h306gy__"